import axios from 'axios';

const { REACT_APP_API_URL: API_URL } = process.env;

export const getVipsByAirport = async (id: string) => {
  const { data: { vips } } = await axios.get(`${API_URL}/vip/${id}`);
  return vips.filter(({ visible }: { visible: boolean }) => visible);
};